<template>
    <div id="campaignsContainer"><!--Root Element-->
        <BreadCrumb></BreadCrumb>
        <h2>Kampagnenübersicht</h2>
        <transition
            name="fade"
            mode="out-in">
            <div key="0" v-if="tableReady">
                <div class="top-bar">
                    <div class="top-bar-left">
                        <InputSearch placeholder="Suche" v-model="searchValue" width="200px"></InputSearch>
                        <Checkbox @change="onFilterChanged" v-model="checked['in Arbeit']" id="filter-in-progress"
                                  title="in Arbeit" icon_status="icon-status-inprogress"
                                  icon_style="color:gray"></Checkbox>
                        <Checkbox @change="onFilterChanged" v-model="checked['gecheckt']" id="filter-checked"
                                  title="gecheckt" icon_status="icon-status-inprogress"
                                  icon_style="color:rgb(1,182,233)"></Checkbox>
                        <Checkbox @change="onFilterChanged" v-model="checked['eingebaut']" id="filter-built-in"
                                  title="eingebaut" icon_status="icon-status-inprogress"
                                  icon_style="color:rgb(215,4,101)"></Checkbox>
                        <Checkbox @change="onFilterChanged" v-model="checked['live']" id="filter-live" title="live"
                                  icon_status="icon-status-live" icon_style="color:rgb(215,4,101)"></Checkbox>
                        <Checkbox @change="onFilterChanged" v-model="checked['pausiert']" id="filter-paused"
                                  title="pausiert" icon_status="icon-status-pause" icon_style="color: #000"></Checkbox>
                        <Checkbox @change="onFilterChanged" v-model="checked['ausgelaufen']" id="filter-finished"
                                  title="ausgelaufen" icon_status="icon-status-finished"
                                  icon_style="color: #000"></Checkbox>
                    </div>
                    <div class="top-bar-right">
                        <AdaButton type="createButton" title="Neue Kampagne" icon="icon-add"
                                   to="/campaigns/create"></AdaButton>
                    </div>
                </div>
                <AdaDatatable :columns="columns" :data="rows" :show-search="false" :size-of-page="10"
                              @rowClicked="cellClicked" :search-value="searchValue" :table-filters="[this.tableFilter]"
                              :transformers="transformers">
                    <div class="bottom-bar" v-on:mouseover="bottomBarHovered = true"
                         @mouseout="bottomBarHovered = false"
                         @click="$router.push({name: 'createCampaign'})">
                        <AdaButton v-on:mouseover="bottomBarHovered = true" @mouseout="bottomBarHovered = false"
                                   :custom-styles="createButtonStyle" icon="icon-add"
                                   font-awesome-icon-name="plus-circle" type="fullWidthButton"
                                   title="NEUE KAMPAGNE ERSTELLEN"></AdaButton>
                    </div>
                </AdaDatatable>
            </div>
            <div key="1" v-else class="loaderContainer">
                <dot-loader id="loader"></dot-loader>
            </div>
        </transition>
        <Dialog v-if="deleteCampaign" :show-close-button="true" :show="showDeleteCampaignDialog" :has-backdrop="true"
                @close="deleteDialogClose">
            <div class="delete-container">
                <h4>Kampagne löschen</h4>
                <div>
                    Soll die Kampagne: <span style="font-weight: bold">{{ this.deleteCampaign.name }}</span> wirklich
                    gelöscht werden?
                </div>
                <AdaButton class="btn-delete" @click="deleteClicked" title="LÖSCHEN" type="createButton"></AdaButton>
            </div>
        </Dialog>
        <Dialog v-if="copyCampaign" :show-close-button="true" :show="showCopyCampaignDialog" :has-backdrop="true"
                @close="showCopyCampaignDialog = false">
            <div class="delete-container">
                <h4>Kampagne kopieren</h4>
                <div>
                    Soll die Kampagne: <span style="font-weight: bold">{{ this.copyCampaign.name }}</span> wirklich
                    kopiert werden?
                </div>
                <AdaButton class="btn-delete" @click="fetchCopyCampaign" title="KOPIEREN"
                           type="createButton"></AdaButton>
            </div>
        </Dialog>
    </div>
</template>

<script>
import AdaDatatable from "../../components/tables/AdaDatatable";
import AdaButton from "../../components/buttons/AdaButton";
import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Dialog from "../../components/dialog/Dialog";
import Checkbox from "../../components/inputs/Checkbox";
import InputSearch from "../../components/inputs/InputSearch";
import BreadCrumb from "../../components/breadCrumb/BreadCrumb";
import Transformers from "../../components/tables/Transformers";

const CampaignsRepository = RepositoryFactory.get('campaigns');

export default {
    components: {
        Checkbox,
        AdaDatatable,
        AdaButton,
        Dialog,
        InputSearch,
        BreadCrumb
    },
    name: "Campaign",
    data: function () {
        return {
            tableFilter: {
                propName: 'status',
                allowedValues: []
            },
            tableReady: false,
            showDeleteCampaignDialog: false,
            showCopyCampaignDialog: false,
            copyCampaign: null,
            deleteCampaign: null,
            searchValue: '',
            checked: {
                "in Arbeit": false,
                "gecheckt": false,
                "eingebaut": false,
                "live": false,
                "pausiert": false,
                "ausgelaufen": false,
            },
            columns: [
                {
                    viewName: 'Kunde',
                    propName: 'customer',
                    sortable: true,
                    width: '250px'
                },
                {
                    viewName: 'Kampagne',
                    propName: 'name',
                    sortable: true,
                    width: '350px'
                },
                {
                    viewName: 'AdSpecial',
                    propName: 'adSpecial',
                    sortable: true,
                    width: '250px'
                },
                {
                    viewName: 'Abteilung',
                    propName: 'department',
                    sortable: true,
                    width: '120px'
                },
                {
                    viewName: 'Erstelldatum',
                    propName: 'created_at',
                    sortable: true,
                    width: '140px',
                    sort: -1
                },
                {
                    viewName: 'Status',
                    propName: 'status',
                    sortable: true,
                    width: '100px'
                },
                {
                    viewName: 'Aktion',
                    propName: 'action',
                    width: '150px'
                }
            ],
            rows: [],
            bottomBarHovered: false,
            transformers: [
                {
                    propName: 'status',
                    transform: function (value) {
                        let res = value;
                        switch (value) {
                            case 'live':
                                res = '<span style="color: rgb(215,4,101)" class="icon-status-live"></span>';
                                break;
                            case 'pausiert':
                                res = '<span style="color: rgb(215,4,101)" class="icon-status-pause"></span>';
                                break;
                            case 'ausgelaufen':
                                res = '<span style="color: rgb(36,39,45)" class="icon-status-finished"></span>';
                                break;
                            case 'in Arbeit':
                                res = '<span style="color: gray" class="icon-status-inprogress"></span>';
                                break;
                            case 'gecheckt':
                                res = '<span style="color: rgb(1,182,233)" class="icon-status-inprogress"></span>';
                                break;
                            case 'eingebaut':
                                res = '<span style="color: rgb(215,4,101)" class="icon-status-inprogress"></span>';
                                break;
                        }
                        return res;
                    }
                },
                {
                    propName: 'created_at',
                    transform: Transformers.dateTransformer
                },
                {
                    propName: 'action',
                    transform: function (value) {
                        let res = '';
                        value.forEach(action => {
                            switch (action) {
                                case 'edit':
                                    res += '<span data-type="edit" class="margin-right hover-highlight icon-edit icon"></span>';
                                    break;
                                case 'copy':
                                    res += '<span data-type="duplicate" class="margin-right hover-highlight icon-duplicate icon"></span>';
                                    break;
                                case 'delete':
                                    res += '<span data-type="delete" class="margin-right hover-highlight icon-delete icon"></span>';
                                    break;
                                case 'dashboard':
                                    res += '<span style="margin-right: 0;" data-type="dashboard" class="margin-right hover-highlight icon-dashboard icon"></span>';
                                    break;
                            }
                        });
                        return res;
                    }
                }
            ]
        }
    },
    created() {
        this.fetchCampaigns();
    },
    computed: {
        createButtonStyle: function () {
            let res = '';
            let bgColor = !this.bottomBarHovered ? 'white' : 'rgb(215,4,101)';
            let textColor = !this.bottomBarHovered ? 'rgb(215,4,101)' : 'white';
            res = `background-color: ${bgColor};color: ${textColor};`;
            return res;
        }
    },
    methods: {
        async deleteClicked() {
            this.showDeleteCampaignDialog = false;
            await CampaignsRepository.deleteCampaign(this.deleteCampaign.id);
            this.$noty.success('Die Kampagne wurde erfolgreich gelöscht!');
            this.deleteCampaign = null;
            this.fetchCampaigns();
        },
        deleteDialogClose: function () {
            this.showDeleteCampaignDialog = false;
        },
        async fetchCampaigns() {
            const {data} = await CampaignsRepository.get();
            this.$log.debug('campaigns loaded', data);
            this.rows = data;
            this.rows.forEach(row => {
                row.action = [
                    'edit',
                    'copy',
                    'delete',
                    'dashboard'
                ]
            });
            this.tableReady = true;
        },
        async fetchCopyCampaign() {
            const {data} = await CampaignsRepository.copyCampaign(this.copyCampaign.id);
            await this.$router.push({name: 'editCampaign', params: {id: data.campaign.id}});
        },
        cellClicked: function (data) {

            let dataType = data.target.getAttribute('data-type');
            if (dataType === null && data.prop !== "action") {
                this.$router.push({name: 'showCampaign', params: {id: data.row.id}});
            }
            switch (dataType) {
                case 'edit':
                    this.$router.push({name: 'editCampaign', params: {id: data.row.id}});
                    break;
                case 'duplicate':
                    this.copyClicked(data.row);
                    break;
                case 'delete':
                    this.showDeleteCampaignDialog = true;
                    this.deleteCampaign = data.row;
                    break;
                case 'dashboard':
                    this.$router.push({name: 'showDashboard', params: {id: data.row.id}});
                    break;
            }
        },
        copyClicked: function (campaign) {
            this.showCopyCampaignDialog = true;
            this.copyCampaign = campaign;
        },
        onFilterChanged: function () {
            this.runFilter();
        },
        runFilter: function () {
            let allowedValues = [];
            for (let key in this.checked) {
                if (this.checked[key]) {
                    allowedValues.push(key);
                }
            }
            this.tableFilter.allowedValues = allowedValues;
        }
    },
    mounted() {
    }
}

</script>

<style lang="scss" scoped>

h4 {
    margin-top: 0;
}

.delete-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.btn-delete {
    margin-top: 32px;
}

.top-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    margin-bottom: 10px;

    ::v-deep .checkbox-container {
        margin-left: 20px;
        margin-right: 10px;
        font-size: 15px;

    }

    ::v-deep .cb-icon {
        right: -11px;
        top: 4px;
        font-size: 7px;
    }

}

.top-bar-left {
    display: flex;
    align-items: center;
    margin: 10px 20px;
}

.top-bar-right {
    display: flex;
    align-items: center;
    margin: 10px 20px;
}

.loaderContainer {
    height: 40vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep .ada-table-container tr {
    display: flex;
}

::v-deep .ada-table-container td {
    display: block;
}

::v-deep .ada-table-container thead th {
    font-weight: 500;
}

::v-deep #trackinglistContent .ada-table th {
    transition: all .3s ease-in-out;

    &.hide {
        width: 0 !important;
        padding: 0;
        overflow: hidden;
        white-space: pre;

        .table-header {
            width: 0;
            margin: 0;
            padding: 0;
            border: none;
        }
    }
}

::v-deep .mainTable {
    .table-header-row {
        float: left
    }
}

</style>